import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { COUNTRY } from '@/lib/format';
import { Flag } from '@/components/Flag';

export default function CountrySelect({ value, onChange, options = ['KE', 'UG'], testId }) {
    const [open, setOpen] = useState(false);
    const cur = COUNTRY[value] || COUNTRY[options[0]];
    return (
        <div style={{ position: 'relative' }}>
            <button
                type="button"
                data-testid={testId}
                onClick={() => setOpen((o) => !o)}
                className="nia-input"
                style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', cursor: 'pointer' }}
            >
                <span style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                    <Flag code={value} size={22} />
                    <span style={{ fontWeight: 700 }}>{cur.name}</span>
                </span>
                <ChevronDown size={18} />
            </button>
            {open && (
                <div style={{
                    position: 'absolute', top: 'calc(100% + 8px)', left: 0, right: 0,
                    background: 'white', border: '1px solid var(--nia-border)', borderRadius: 16,
                    boxShadow: '0 12px 30px rgba(10,46,40,0.12)', zIndex: 20, overflow: 'hidden',
                }}>
                    {options.map((code) => {
                        const c = COUNTRY[code];
                        return (
                            <button
                                key={code}
                                type="button"
                                onClick={() => { onChange(code); setOpen(false); }}
                                style={{
                                    display: 'flex', alignItems: 'center', gap: 10,
                                    width: '100%', padding: '14px 16px', border: 'none',
                                    background: value === code ? 'var(--nia-primary-tint)' : 'white',
                                    cursor: 'pointer', textAlign: 'left',
                                }}
                            >
                                <Flag code={code} size={20} />
                                <span style={{ fontWeight: 700 }}>{c.name}</span>
                                <span style={{ marginLeft: 'auto', color: 'var(--nia-subtext)', fontSize: 13 }}>{c.dial}</span>
                            </button>
                        );
                    })}
                </div>
            )}
        </div>
    );
}
